<template>
    <div class="show-more">
        <div ref="textContentRef" class="show-more_text-content" :class="{unwrapped: showMore}">
            <slot name="text-content" />
        </div>
        <slot v-if="slots['additional-content'] && showMore" name="additional-content" />
        <div v-if="isScrollingY || (!isScrollingY && showMore) || slots['additional-content']" class="show-more_button" @click="showMore = !showMore">
            <span v-if="showMore">{{ $t('projectclient.general.show.less') }}</span>
            <span v-else>{{ $t('projectclient.general.show.more') }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {ref, useTemplateRef} from 'vue';
    import {useScrollContainer} from '@malt/utils';

    withDefaults(
        defineProps<{
            lines: number;
        }>(),
        {lines: 2},
    );

    const slots = defineSlots<{
        'text-content': any;
        'additional-content'?(): any;
    }>();

    const showMore = ref(false);

    const textContentRef = useTemplateRef('textContentRef');

    const {isScrollingY} = useScrollContainer({target: textContentRef});
</script>

<style lang="scss" scoped>
    .show-more {
        min-width: 0;

        &_text-content {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: v-bind(lines);
            line-clamp: v-bind(lines);
            overflow: hidden;
            white-space: pre-wrap;
            min-width: 0;
            max-width: 100%;
            overflow-wrap: anywhere;

            &.unwrapped {
                display: block;
                -webkit-line-clamp: initial;
                line-clamp: initial;
                overflow: visible;
            }
        }

        &_button {
            padding: var(--joy-core-spacing-2) 0;

            span {
                color: var(--joy-color-secondary-30);
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
